import React from 'react';
import type { ExperimentContextType } from '../../experiments/types';

export const ExperimentContext = React.createContext<ExperimentContextType | null>(null);
